import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen px-4 text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "inline-block h-screen align-middle",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block w-96 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-app-gray-700 shadow rounded-md" }
const _hoisted_4 = { class: "mt-4 mx-8 mb-8" }
const _hoisted_5 = { class: "text-center font-header text-md font-bold text-app-text-500 dark:text-app-text-dark-500" }
const _hoisted_6 = {
  key: 0,
  class: "text-center mt-3 font-body text-base text-app-text-500 dark:text-app-text-dark-500"
}

import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon, XCircleIcon, XIcon } from "@heroicons/vue/solid";
import { Button } from "@toruslabs/vue-components";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import ControllersModule from "@/modules/controllers";
import { STATUS, STATUS_TYPE } from "@/utils/enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageModal',
  props: {
    isOpen: { type: Boolean, default: false },
    title: {},
    description: { default: "" },
    status: { default: STATUS.INFO }
  },
  emits: ["onClose"],
  setup(__props: any, { emit: emits }) {



const { t } = useI18n();


const closeModal = () => {
  emits("onClose");
};

const isDarkMode = computed(() => {
  return ControllersModule.isDarkMode;
});

const refDiv = ref(null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: _ctx.isOpen,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        open: _ctx.isOpen,
        class: _normalizeClass({ dark: isDarkMode.value }),
        as: "div",
        "initial-focus": refDiv.value,
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "refDiv",
            ref: refDiv,
            class: "fixed inset-0 z-40 overflow-y-auto"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 opacity-30 bg-gray-200 dark:bg-gray-500" }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(DialogTitle), {
                      as: "div",
                      class: "bg-white dark:bg-app-gray-700 shadow dark:shadow-dark rounded-md flex justify-center py-8 relative",
                      tabindex: "0"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.status === _unref(STATUS).SUCCESS)
                          ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                              key: 0,
                              class: "w-20 h-20 text-app-success"
                            }))
                          : (_ctx.status === _unref(STATUS).ERROR)
                            ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                                key: 1,
                                class: "w-20 h-20 text-app-error dark:text-app-red-400"
                              }))
                            : (_ctx.status === _unref(STATUS).WARNING)
                              ? (_openBlock(), _createBlock(_unref(ExclamationCircleIcon), {
                                  key: 2,
                                  class: "w-20 h-20 text-app-warning"
                                }))
                              : (_openBlock(), _createBlock(_unref(InformationCircleIcon), {
                                  key: 3,
                                  class: "w-20 h-20 text-app-info"
                                })),
                        _createVNode(_unref(XIcon), {
                          class: "w-6 h-6 absolute top-3 right-3 text-app-text-500 cursor-pointer",
                          onClick: closeModal
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1),
                      (_ctx.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.description), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(Button), {
                        class: "mt-5",
                        block: true,
                        variant: "tertiary",
                        onClick: closeModal
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("walletHome.close")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ], 512)
        ]),
        _: 1
      }, 8, ["open", "class", "initial-focus"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})